import { z } from "zod";

// Phone number validation regex that accepts standard formats:
// - 1234567890
// - 123-456-7890
// - (123) 456-7890
// - +1 123 456 7890
const phoneRegex = /^(\+?1[-\s]?)?\(?([0-9]{3})\)?[-\s]?([0-9]{3})[-\s]?([0-9]{4})$/;

export const userSchema = z.object({
    // username: z.string().optional(),
    name: z.string(),
    // firstName: z.string().optional(),
    // lastName: z.string().optional(),
    email: z.string().optional(),
    phoneNumber: z.string().regex(phoneRegex, "Please enter a valid phone number").optional(),
    companyName: z.string().optional()
});

const passwordRequirementError = "Password must contain at least 8 characters, have 1 uppercase letter, 1 lowercase letter, and 1 special character";
export const signUpSchema = z
    .object({
        name: z.string().min(1, "Name is required."),
        companyName: z.string().min(1, "Company name is required."),
        email: z.string().email(),
        phoneNumber: z.string().regex(phoneRegex, "Please enter a valid phone number"),
        password: z.string()
            .min(8, passwordRequirementError)
            .regex(/(?=.*[A-Z])/, passwordRequirementError)
            .regex(/(?=.*[a-z])/, passwordRequirementError)
            .regex(/(?=.*[!@#$%^&*(),.?":{}|<>])/, passwordRequirementError),
        confirmPassword: z.string()
            .min(8, passwordRequirementError)
            .regex(/(?=.*[A-Z])/, passwordRequirementError)
            .regex(/(?=.*[a-z])/, passwordRequirementError)
            .regex(/(?=.*[!@#$%^&*(),.?":{}|<>])/, passwordRequirementError),
        partnershipCode: z.string().optional()
    })
    .refine((data) => data.password === data.confirmPassword, { message: "Passwords don't match", path: ["confirmPassword"] });

export const loginSchema = z.object({
    email: z.string().email(),
    password: z.string().min(8, "Password must contain at least 8 character(s)") // leave as is for backwards compatibility
});

export const resetSchema = z.object({
    email: z.string().email()
});

export const carrierSchema = z.object({
    UPS: z.boolean(),
    FedEx: z.boolean(),
    Purolator: z.boolean(),
    GLS: z.boolean()
});
